import React from 'react'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string
}

type TypeCellProps = {
  rowData?: RowData,
  dataKey: string
}

const typeMappings: Record<string, string> = {
  HOME_SCREEN: 'Home Screen',
  REPORT_PAGE: 'Report Page',
  BANNER_ADS: 'Banner Ads',
  INTERSTITIAL_ADS: 'Interstitial Ads',
  REWARDED_ADS: 'Rewarded Ads',
  VIDEO_ADS: 'Video Ads',
  ENGLISH: 'English',
  HINDI: 'Hindi',
  MARATHI: 'Marathi'
}

const TypeCell: React.FC<TypeCellProps> = ({ rowData, dataKey, ...props }) => {
  const rawValue = rowData?.[dataKey]
  const formattedValue = typeMappings[rawValue ?? ''] ?? rawValue ?? 'None'

  return (
    <Cell {...props}>
      <span className="type-cell">{formattedValue}</span>
    </Cell>
  )
}

export default TypeCell
